export const LIGHT_MODE = `lightMode`;
export const DARK_MODE = `darkMode`;